// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bfa_a bii_rj bii_rk bii_vh bii_eb bii_vf bii_gu bii_kh"};